import { BaseService } from "./BaseService";
import { Configuration } from "Configuration";
import { Navigation, App, PageContext } from "Core";
import { TextBlockService, CommandService } from "Service";
import {
    UserClient,
    BaseResult,
    StartPageRequestParameter,
    UserPickerItem,
    DataRequestOption,
    DropDownRequestParameter,
    CommandResult,
    MultipleControlRequestParameter,
} from "./Client";
import { IDataRow, IODataResult } from "Entities";

/**
 * User services.
 *
 * Service which provides access to user data and functionality.
 * @hidden
 */
export class UserService extends BaseService {
    protected getBeforeSend(): any {
        return function (xhr: JQueryXHR) {
            let app = <App>(<any>window).app;
            xhr.setRequestHeader("Authorization", "Bearer " + app.auth.user.access_token);
        };
    }

    private textBlockService: TextBlockService;

    /**
     * Create a new UserService.
     * @param textBlockService
     * @param menuService
     */
    constructor(textBlockService: TextBlockService) {
        super();
        this.textBlockService = textBlockService;
    }

    public async getUser(id: number): Promise<UserPickerItem> {
        let client = new UserClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        let param = CommandService.getPageTokenParameter();
        return new Promise<UserPickerItem>((resolve, reject) => {
            client.getUser(
                id,
                param,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Sets currently visit website as startpage.
     */
    public async setStartPage(): Promise<BaseResult> {
        let baseUrlLength = $("base").attr("href").length; // /DMS_Test/ or /
        let startPage = document.location.pathname + document.location.search; // f.i: /DMS_Test/DMS/tst_ctl...
        startPage = startPage.slice(baseUrlLength, startPage.length); // f.i: DMS/tst_ctl..
        let execute = await Navigation.confirmAsync(this.textBlockService.get("confirmSetStartPage", "userdata"), " ");
        if (!execute) {
            return;
        }
        let params = <StartPageRequestParameter>CommandService.getPageTokenParameter();
        params.StartPage = "~/" + startPage;

        let client = new UserClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return new Promise<BaseResult>((resolve, reject) => {
            client.setStartPage(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Get data for all comboboxes in an EditContext.
     * @param gridId Id of the grid.
     * @param options List of request options.
     * @param dataRow Current datarow in grid / form.
     */
    public getAll(gridId: number, options: DataRequestOption[], dataRow: IDataRow): Promise<{ [controlID: number]: IODataResult }> {
        let client = new UserClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        let param = <MultipleControlRequestParameter>(
            $.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOptions: options })
        );

        return this.handleResult(
            new Promise<{ [controlID: number]: IODataResult }>((resolve, reject) => {
                /*let xhr = */ client.get(
                    gridId,
                    param,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    /**
     * Get data for a single combobox.
     * @param gridId Id of the grid.
     * @param controlId Id of the combobox control.
     * @param option Request option.
     * @param dataRow Current datarow in grid / form.
     */
    public get(gridId: number, controlId: number, option: DataRequestOption, dataRow: IDataRow): Promise<IODataResult> {
        let client = new UserClient(Configuration.baseUrl);
        let params = <DropDownRequestParameter>(
            $.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOption: option })
        );
        client.beforeSend = this.getBeforeSend();

        return new Promise<CommandResult>((resolve, reject) => {
            client.getControl(
                gridId,
                controlId,
                params,
                (res) => resolve(res),
                (exc, res) => reject(exc)
            );
        });
    }

    /**
     * Log off the current user.
     */
    public logout(): void {
        (<App>(<any>window).app).auth.logout();
    }

    /**
     * Open the textblock page for current page.
     */
    public openTextBlocks(): void {
        Navigation.openWindow(
            "/DMS/int_TextBlock?pagemode=dialog&category=" + PageContext.getCurrentTextBlockCategory().toLowerCase(),
            "width=1620,height=909,resizable=yes"
        );
    }

    public changePassword(): void {
        Navigation.openWindow(
            "/Account/ChangePassword?pagemode=dialog",
            "width=800,height=600,resizable=yes"
        );
    }
}
